exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-label{min-width:0;display:flex;align-items:center}.fts-automation-label .automation-label__icon{margin-right:.375rem;color:var(--fts-default)}.fts-automation-label .automation-label__icon.automation-label__icon--moji{flex:0 0 auto}.fts-automation-label .automation-label__name{min-width:0}.fts-automation-label .automation-label__name .automation-label-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
